<section id="site-slider">
    <carousel [noWrap]="noWrapSlides" [showIndicators]="showIndicator">
        <slide class="" *ngFor="let item of slides">
            <div class="wrapper" style="width: 100%;">
                <div class=" bx-wrapper" style="max-width: 100%;">
                    <div class="bx-viewport" style="width: 100%; overflow: hidden; position: relative;">
                        <ul class="bxslider" style="width: auto; position: relative;">
                            <li style="float: none;">
                                <div class="slide-image">
                                    <img src="{{item.image}}" alt="Chicago" style="width:100%;">
                                </div>
                                <!-- <div class="slide-caption padding-all">
                                    <div class="wrapper">
                                        <div class="v-center">
                                            <h5 class="line-bottom">{{item.text| uppercase}}</h5>
                                            <h2 class="text-space">{{item.text | uppercase}}</h2>
                                            <div class="team-desc">
                                                <h3>{{item.text | uppercase}}</h3>
                                            </div>
                                            <div class="button-group clearfix">
                                                <a class="btn btn-border" [routerLink]="[item.text]">{{item.text | uppercase}}
                                                </a>
                                                <a class="btn btn-border" [routerLink]="[item.text]">{{item.text | uppercase}}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </slide>

    </carousel>

</section>